const state = {
  total_count: 0,
  student_list: [{
    slug: '',
    username: '',
    get_full_name: '',
    gender: '',
    step: 0,
    photo_url: '',
    trusted: true,
    role_title: '',
    is_member_of_local_platoon: false,
    is_member_of_city_platoon: false,
    is_member_of_province_platoon: false,
    is_member_of_nation_platoon: false,
    univ_status: '',
  }],
}

const getters = {
  StudentList: state => state.student_list,
  StudentTotalCount: state => state.total_count,
}

const mutations = {
  setStudentList(state, payload) { state.student_list=payload.list; state.total_count=payload.total_count },
  setStudentListPush(state, payload) { state.student_list=state.student_list.concat(payload.list); state.total_count=payload.total_count },
  setTrustInStudentList(state, payload) { state.student_list[state.student_list.map(item => item.slug).indexOf(payload.slug)].trusted=payload.trusted },
  setUserUpdateInStudentList(state, payload) {
    let i = state.student_list.map(item => item.slug).indexOf(payload.slug);
    state.student_list[i].get_full_name=payload.full_name;
    state.student_list[i].step=payload.step;
  },
  setUserPhotoInStudentList(state, payload) { state.student_list[state.student_list.map(item => item.slug).indexOf(payload.slug)].photo_url=payload.photo_url },
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
